import "../../shared/utilities/freeze_scrolling.js";

window.Sparkle ??= {};

Sparkle.Dropdown = class Dropdown {
  constructor(content, options) {
    this.render = this.render.bind(this);
    this.handleTabletBreakpointEnter = this.handleTabletBreakpointEnter.bind(this);
    this.handleTabletBreakpointExit = this.handleTabletBreakpointExit.bind(this);
    this.handleTriggerClicked = this.handleTriggerClicked.bind(this);
    this.handleTriggerKeyUp = this.handleTriggerKeyUp.bind(this);
    this.handleBodyClicked = this.handleBodyClicked.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.isTriggerClick = this.isTriggerClick.bind(this);
    this.triggerEvent = this.triggerEvent.bind(this);
    this.handlePageShow = this.handlePageShow.bind(this);
    this.options = jQuery.extend(
      {
        trigger: null,
        freezeScroll: false,
        menuOpen: false,
        onOpen: null, // callback that executes when the dropdown is opened
        onClose: null, // callback that executes when the dropdown is closed
      },
      options,
    );

    // INITIALIZE

    this.el = jQuery("<div class='dropdown'></div>");
    this.trigger = jQuery(this.options.trigger);
    this.dropdownMenu = jQuery("<div class='dropdown-menu'></div>").append(content);
    this.menuOpen = this.options.menuOpen;

    this.el.hide();
    this.el.css("visibility", "visible");

    // BEHAVIOUR

    new Sparkle.Responsive.mediaCheck({
      media: "(max-width:" + Sparkle.Responsive.Entities.tablet + "px)",
      entry: this.handleTabletBreakpointEnter,
      exit: this.handleTabletBreakpointExit,
    });

    jQuery(document).on("click", this.handleBodyClicked);
    this.trigger.on("click", this.handleTriggerClicked);
    this.trigger.on("keyup", this.handleTriggerKeyUp);
    jQuery(window).on("pageshow", this.handlePageShow);
  }

  render() {
    return this.el.append(this.dropdownMenu);
  }

  // EVENT HANDLERS

  handleTabletBreakpointEnter() {
    return (this.isTabletSize = true);
  }

  handleTabletBreakpointExit() {
    this.isTabletSize = false;
    return this.closeMenu();
  }

  handleTriggerClicked(event) {
    return this.toggleMenu();
  }

  handleTriggerKeyUp(event) {
    if (!window.Sparkle.Events.isKeyUpEnter(event)) {
      return;
    }
    return this.toggleMenu();
  }

  handleBodyClicked(event) {
    if (this.isTriggerClick(event)) {
      return;
    }
    return this.closeMenu();
  }

  handlePageShow(event) {
    if (event.originalEvent.persisted) {
      this.closeMenu();
    }
  }

  // HELPERS

  toggleMenu() {
    if (this.menuOpen) {
      return this.closeMenu();
    } else {
      return this.openMenu();
    }
  }

  openMenu() {
    this.menuOpen = true;
    if (this.options.freezeScroll) {
      Sparkle.Utilities.Scrolling.freeze();
    }
    if (this.options.onOpen) {
      this.options.onOpen(this.isTabletSize);
    }
    this.el.show();
    return this.triggerEvent("dropdownopen.sparkle");
  }

  closeMenu() {
    this.menuOpen = false;
    if (this.options.freezeScroll) {
      Sparkle.Utilities.Scrolling.unfreeze();
    }
    if (this.options.onClose) {
      this.options.onClose(this.isTabletSize);
    }
    this.el.hide();
    return this.triggerEvent("dropdownclose.sparkle");
  }

  isTriggerClick(event) {
    const target = jQuery(event.target);
    return !!target.closest(this.trigger).length;
  }

  triggerEvent(event, ...payload) {
    return jQuery(this.el).trigger(event, payload);
  }
};
